<template>
  <div class="h-100">
<!--    loader  -->
    <div v-if="false" class="loading_page" style=" padding: 10px; background: #1e1e1e; opacity: 0.6;">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>

    <b-sidebar
        :visible="pathsSideBarStatus"
        :backdrop="false"
        right
        id="paths-sidebar"
        sidebar-class="sidebar-lg"
        shadow
        style="opacity: 0.94"
        @hidden="hideSideBar"
        width="40%">


<!--      #0e96b1-->
      <div v-if="false" class="loading_page" style=" padding: 10px; background: #1e1e1e; opacity: 0.2;">
        <orbit-spinner :animation-duration="1000" :size="50" :color="'white'"/>
      </div>

      <div dir="rtl" class="m-2">

        <b-tabs>
          <b-tab>

            <template #title>
              <img class="mr-50" style="width: 18px" :src="require('@/assets/icons/path.png')" alt="">
              <span class="font-weight-bold">{{ $t('المسارات')}}</span>
            </template>

            <!--        filters    -->

            <b-card no-body>
              <b-card-header class="pb-50">
                <h5> {{ $t('Paths Filters') }} </h5>
              </b-card-header>
              <b-card-body>
                <b-row>
                  <b-col lg="12" md="12" class="mb-md-0 mb-2 text-left" >
                    <label>{{ $t('Contracts') }}</label>
                    <v-select multiple :close-on-select="false" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                              v-model="contracts"
                              :options="contractsOptions" class="w-100"/>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>


            <!--        table    -->

            <b-card no-body>
              <b-card-header class="pb-50">
                <h5> {{ $t('Paths List') }} </h5>
              </b-card-header>
              <b-card-body>
                <b-row class="mb-2">
                  <!-- Search -->
                  <b-col cols="12" md="6">
                    <div class="d-flex align-items-center justify-content-end">
                      <b-form-input
                          v-model="searchQuery"
                          class="d-inline-block mr-1"
                          :placeholder="$t('Search...')"
                      />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-table responsive small
                      :items="filteredItems"
                      :fields="fields.map((i) => ({ key: i.key, label: $t(i.key), sortable: i.sortable}))"
                      show-empty
                      :empty-text="$t('No matching records found')">

                      <template #cell(idd)="data"> {{ data.index + 1 }}</template>
                      <template #cell(name)="data">
                        <b @click="fitOnLine(data.item.id)" class="text-info cursor-pointer">{{ data.item.name }}</b>
                      </template>
                      <template #cell(percent)="data"> {{ data.item.percent }}%</template>
                      <template #cell(show)="data">
                        <div class="d-flex justify-content-center align-items-center">
                          <b-form-checkbox @change="pathViability(data.item.id, $event)" :checked="true">
                          </b-form-checkbox>
                        </div>
                      </template>

                  </b-table>
                </b-row>

                <div class="mx-2 mb-2 mt-2">
                  <span class="text-muted">{{ $t('Show') }} {{ filteredItems.length }} {{ $t('entries') }} </span>
                </div>

              </b-card-body>
            </b-card>


          </b-tab>


          <b-tab lazy>
            <template #title>
              <img class="mr-50" style="width: 18px" :src="require('@/assets/icons/container.png')" alt="">
              <span class="font-weight-bold">{{ $t('Containers')}}</span>
            </template>


            <b-card no-body>
              <b-card-header class="pb-50">
                <h5> {{ $t('Containers Filters') }} </h5>
              </b-card-header>
              <b-card-body>
                <b-row>
                  <b-col lg="12" md="12" class="mb-md-0 mb-2 text-left" >
                    <label>{{ $t('Contracts') }}</label>
                    <v-select multiple :close-on-select="false" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                              v-model="contracts"
                              :options="contractsOptions" class="w-100"/>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12" md="12" class="mb-md-0 mb-2 text-left" >
                    <label>{{ $t('Paths') }}</label>
                    <v-select multiple :close-on-select="false" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                              v-model="selectedPaths"
                              :options="pathsOptions" class="w-100"/>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col lg="12" md="12" class="mb-md-0 mb-2 text-left" >
                    <label>{{ $t('last lift') }}</label>
                    <v-select multiple :close-on-select="false" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                              v-model="selectedLastLift"
                              :options="lastLiftOptions.map((i) => ({key: i.key, label: $t(i.label)}))" class="w-100"/>
                  </b-col>
                </b-row>

              </b-card-body>
            </b-card>



            <!--        table    -->

            <b-card no-body>
              <b-card-header class="pb-50">
                <h5> {{ $t('Containers List') }} </h5>
              </b-card-header>
              <b-card-body>
                <b-row class="mb-2">
                  <!-- Per Page -->

                  <!-- Search -->
                  <b-col cols="12" md="6">
                    <div class="d-flex align-items-center justify-content-end">
                      <b-form-input
                          v-model="containerSearchQuery"
                          class="d-inline-block mr-1"
                          :placeholder="$t('Search...')"
                      />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-table responsive small
                           :items="filteredContainers"
                           :fields="containers_fields.map((i) => ({ key: i.key, label: $t(i.key), sortable: i.sortable}))"
                           show-empty
                           :empty-text="$t('No matching records found')">

                    <template #cell(idd)="data"> {{ data.index + 1 }}</template>
                    <template #cell(tag)="data">
                      <b @click="fitOnContainer(data.item)" class="text-info cursor-pointer">{{ data.item.tag }}</b>
                    </template>
                  </b-table>
                </b-row>

                <div class="mx-2 mb-2 mt-2">
                  <span class="text-muted">{{ $t('Show') }} {{ filteredContainers.length }} {{ $t('containers') }} </span>
                </div>

              </b-card-body>
            </b-card>

          </b-tab>

        </b-tabs>

      </div>

    </b-sidebar>


<!--    map    -->
    <div dir="ltr" class="h-100">
      <div class="h-100" id="map" ref="mapContainer"></div>
    </div>

  </div>
</template>


<script>
import {
  BAlert,
  BAvatar,
  BAvatarGroup,
  BButton, BCard, BCardBody, BCardHeader, BCardText, BCardTitle,
  BCol,
  BCollapse,
  BForm, BFormCheckbox,
  BFormGroup, BFormInput,
  BFormInvalidFeedback, BImg, BMedia, BMediaAside, BMediaBody, BPagination,
  BRow, BSidebar, BTab, BTable, BTabs
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { computed, onMounted, ref } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import axios from '@/libs/axios'
import { eventBus } from '@/main'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AlertIcon from '@/views/components/alert/AlertIcon.vue'
import Path from '@/views/maps/ContainersPaths/Path'
import router from '@/router'


export default {
  components: {
    BTab,
    BTabs,
    BPagination,
    BFormInput,
    BTable,
    BCardText,
    BFormCheckbox,
    BAlert,
    AlertIcon,
    BCard,
    BCardHeader,
    BCardTitle,
    BSidebar,
    BMedia,
    BCardBody,
    BImg,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BAvatarGroup,
    AppTimeline,
    AppTimelineItem,
    vSelect,
    BFormInvalidFeedback,

    BCollapse,
    BButton,
    BRow,
    BCol,
    flatPickr,
    OrbitSpinner
  },

  setup() {

    const pathsSideBarStatus = ref(true)
    const perPage = ref(25)
    const currentPage = ref(25)

    const searchQuery = ref('')
    const containerSearchQuery = ref('')

    const paths = ref({})
    const items = ref([])

    const filteredItems = computed(() => {

      return items.value.filter(item => {
        const matchesContracts = contracts.value.length === 0 || contracts.value.includes(item.contract);
        const matchesSearch = item.name.toLowerCase().includes(searchQuery.value.toLowerCase())
            || item.device.toLowerCase().includes(searchQuery.value.toLowerCase())
            || item.contract.toLowerCase().includes(searchQuery.value.toLowerCase())
            || item.lastupdate.toLowerCase().includes(searchQuery.value.toLowerCase())

        return matchesContracts && matchesSearch

      })
    })

    const containers = ref([])

    const filteredContainers = computed(() => {

      return containers.value.filter(item => {

        let matchesLastupdate = false;
        const matchesContracts = contracts.value.length === 0 || contracts.value.includes(item.contract);

        if (selectedLastLift.value.length > 0) {
          const lastupdate_sec = (new Date() - new Date(item.lastupdate)) / 1000
          for (const i in selectedLastLift.value) {
            switch (selectedLastLift.value[i].key) {
              case 1:
                if (lastupdate_sec <= 24 * 3600) matchesLastupdate = true
                break
              case 2:
                if (lastupdate_sec > 24 * 3600 && lastupdate_sec < 48 * 3600) matchesLastupdate = true;
                break
              default:
                if (lastupdate_sec >= 48 * 3600) matchesLastupdate = true
            }
          }

        }
        else {
          matchesLastupdate = true
        }

        const matchesSearch = item.tag.toLowerCase().includes(containerSearchQuery.value.toLowerCase())
            || item.code.toLowerCase().includes(containerSearchQuery.value.toLowerCase())
            || item.contract.toLowerCase().includes(containerSearchQuery.value.toLowerCase())
            || item.path.toLowerCase().includes(containerSearchQuery.value.toLowerCase())
            || item.lastupdate.toLowerCase().includes(containerSearchQuery.value.toLowerCase())

        return matchesContracts && matchesSearch && matchesLastupdate

      })

    })

    const selectedPath = ref(0)
    const contracts = ref([])

    const selectedPaths = ref([])
    const selectedLastLift = ref([])

    const contractsOptions = ref([])
    const pathsOptions = ref([])

    const lastLiftOptions = [{key: 1, label:"last 24 hours"}, {key: 2, label:"yesterday"}, {key: 3, label:"before 3 days or more"}]
    const fields = [{key:'idd'}, {key:'name'}, {key:'contract'}, {key:'device'}, {key:'containers'}, {key:'lifted'}, {key:"lastupdate", sortable: true}, {key:'percent', sortable: true}, {key:'show'}]
    const containers_fields = [{key:'idd'}, {key:'contract'}, {key:'path'}, {key:'tag'}, {key:'code'}, {key:"lastupdate", sortable: true}]

    const mapContainer = ref(null);

    let map = null


    const getPaths = async () => {

      const res = await axios.get('/getContainersPaths')
      if (res.status === 200) {

        for (const i in res.data) { // for each path

          let containers_data = []
          let containers_points = []
          let path = extractPath(res.data[i].path[0].area)

          if (path.length > 0) {

            contractsOptions.value.push(res.data[i].contract)
            pathsOptions.value.push(res.data[i].path[0].name)

            for (const j in res.data[i].containers) {
              let c = res.data[i].containers[j]

              containers.value.push({
                pathid: res.data[i].id,
                contract: res.data[i].contract,
                path: res.data[i].path[0].name,
                tag: c.tag,
                code: c.code,
                lastupdate: c.lastupdate,
              })

              containers_points.push([parseFloat(c.lat), parseFloat(c.lng)])
              containers_data.push({
                tag: c.tag,
                code: c.code,
                lastupdate: c.lastupdate,
              })
            }

            paths.value[res.data[i].id] = new Path(map, path, containers_points, containers_data, {
                  id: res.data[i].id,
                  device: res.data[i].device,
                  owner: res.data[i].owner,
                  contract: res.data[i].contract,
                  pathName: res.data[i].path[0].name
                }
            )
          }
        }

        const eventsResponse = await axios.get('/getContainersPathsLifted')
        if (eventsResponse.status === 200) {
          for (const pathId in eventsResponse.data) {
            for (const j in eventsResponse.data[pathId]) {
              paths.value[pathId].readContainer({
                tag: eventsResponse.data[pathId][j].tag,
                lastupdate: eventsResponse.data[pathId][j].event_time
              })
            }
          }
        }

        let bounds = L.latLngBounds()
        for (const i in paths.value) {
          bounds.extend(paths.value[i].getBounds())
          items.value.push(paths.value[i].getTableRow())
        }

        map.flyToBounds(bounds);

      }

    }

    const extractPath = area => {
      if (area.slice(0,1) !== "L") return []
      const coordinatesString = area.replace('LINESTRING (', '').replace(')', '');
      const coordinatePairs = coordinatesString.split(', ');
      return coordinatePairs.map(pair => pair.split(' ').map(Number))
    }
    const initMap = () => {

      if (mapContainer.value) {
        let map_center = store.state.auth.userData?.map?.center ?? [24.7136, 46.6753]
        map = L.map(mapContainer.value).setView(map_center, 13);
        const googleStreets = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{ maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3'] }).addTo(map);
        const googleHybrid = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{ maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3'] })
        map.on('click', onMapClick);
        L.control.layers({googleStreets, googleHybrid }, {},{ position: 'topleft'}).addTo(map)
      }
    };
    const onMapClick = (event) => {
      const { lat, lng } = event.latlng;
    };

    const hideSideBar = () => {
      pathsSideBarStatus.value = false
    }

    const pathViability = (id, isChecked) => {
      isChecked
          ? paths.value[id].show()
          : paths.value[id].hide()
    }


    const fitOnLine = id => {
      map.flyToBounds(paths.value[id].getBounds())
    }

    const fitOnContainer = item => {
      paths.value[item.pathid].fitOnContainer(item.tag)
    }

    onMounted( () => {

      document.getElementsByTagName('html')[0].dir = 'ltr'

      initMap();
      getPaths()

      const CustomControl = L.Control.extend({
        onAdd: function(map) {

          const container = L.DomUtil.create('div', 'custom-control')


          // paths
          const pathsButton = L.DomUtil.create('button', 'custom-button', container)
          const icon = L.DomUtil.create('img', 'button-icon', pathsButton);
          icon.src = require('@/assets/icons/path.png')

          pathsButton.addEventListener('click', function() {
            pathsSideBarStatus.value = !pathsSideBarStatus.value;
          })


          // dashboard
          const HomeButton = L.DomUtil.create('button', 'custom-button', container)
          const HomeIcon = L.DomUtil.create('img', 'button-icon', HomeButton);
          HomeIcon.src = require('@/assets/icons/home.png')

          HomeButton.addEventListener('click', function() {
            router.push({ name: 'dashboard' })
          })


          return container;
        }
      })

      const customControl = new CustomControl()
      customControl.addTo(map);

    });

    return {

      contracts,
      selectedPaths,
      selectedLastLift,
      contractsOptions,
      pathsOptions,
      lastLiftOptions,

      mapContainer,
      map,

      selectedPath,

      filteredItems,
      filteredContainers,

      fields, containers_fields,
      perPage,
      currentPage,
      searchQuery, containerSearchQuery,

      pathsSideBarStatus,
      hideSideBar,
      pathViability,
      fitOnLine, fitOnContainer
    }

  }

};
</script>
<style lang="less">

.button-icon {
  width: 25px;
}
.leaflet-map-pane svg {
  z-index: 100 !important;
}

.leaflet-div-icon {
  border: none !important;
  background: none !important;
}

.custom-button {
  all: unset;
  display: inline-block;
  cursor: pointer;

  background: white;
  margin: 2px;
  padding: 2px;
  border: 2px solid #1676e5;
  border-radius: 2px;

}

.h-100 > div {
  height: 100%;
}

.b-sidebar-outer{
  height: 0 !important;
}

.leaflet-popup-content {
  margin: 0 0 0 0 !important;
}

.leaflet-popup-content-wrapper {
  border-radius: 1px !important;
}

.pulse {
  background: rgb(163, 241, 9);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: absolute;
  margin-left: -10px;
  margin-top: -10px;
  animation: pulse 1s ease-out infinite;
}


@keyframes pulse {
  0% {box-shadow: 0 0 0 0;}
  70% {box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);}
  100% {box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);}
}

</style>
